import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  collection,
  collectionSnapshots,
  Firestore,
} from '@angular/fire/firestore';
import {
  AsymmetryVariableRanges,
  AsymmetryVariableRangesClass,
} from '@sleipai/sleip-models';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AsymmetryVariableRangesService {
  constructor() {}

  private firestore = inject(Firestore);
  private destroyRef = inject(DestroyRef);

  getAsymmetryVariableRanges(): Observable<AsymmetryVariableRanges[]> {
    return collectionSnapshots(
      collection(
        this.firestore,
        `/common/frontendParameters/asymmetryVariableRanges`
      )
    ).pipe(
      takeUntilDestroyed(this.destroyRef),
      map((actions) => {
        return actions.map((a) => {
          const data = a.data();
          const id = a.id;
          return new AsymmetryVariableRangesClass({ id, ...data });
        });
      })
    );
  }
}
